(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dam-dma-senior-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('.dds-site-scope');
  if (!root) return;
  document.body.classList.add('dds-active');
  /* DDS defensive scroll-state reset */
  document.body.classList.remove('dds-menu-open');
  if (!document.documentElement.hasAttribute('scroll-lock')) {
    document.documentElement.style.removeProperty('overflow');
  }

  const panel = root.querySelector('[data-dds-mega]');
  const openers = root.querySelectorAll('[data-dds-open]');
  const closer = root.querySelector('[data-dds-close]');
  const main = root.querySelector('#dds-main');
  const header = root.querySelector('[data-dds-header]');
  const filterInput = panel?.querySelector('[data-dds-filter]');
  const filterClear = panel?.querySelector('[data-dds-filter-clear]');
  const filterStatus = panel?.querySelector('[data-dds-filter-status]');
  const noResults = panel?.querySelector('[data-dds-no-results]');
  const routeLinks = panel ? Array.from(panel.querySelectorAll('.dds-mega__grid .dds-mega__link')) : [];
  const routeGroups = panel ? Array.from(panel.querySelectorAll('.dds-mega__group')) : [];
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let lastFocus = null;
  let previousOverflow = '';

  const getFocusable = () => panel ? Array.from(panel.querySelectorAll(focusableSelector)).filter((element) => element.getClientRects().length > 0) : [];
  const isOpen = () => panel?.classList.contains('is-open');
  const normalize = (value) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('nl-NL').trim();

  const applyFilter = () => {
    const query = normalize(filterInput?.value);
    let visible = 0;

    routeLinks.forEach((link) => {
      const routeKey = link.getAttribute('href')?.split('/').filter(Boolean).pop() ?? '';
      const haystack = normalize(`${link.textContent} ${routeKey}`);
      const match = !query || haystack.includes(query);
      link.hidden = !match;
      if (match) visible += 1;
    });

    routeGroups.forEach((group) => {
      const hasVisibleLink = Array.from(group.querySelectorAll('.dds-mega__link')).some((link) => !link.hidden);
      group.hidden = !hasVisibleLink;
    });

    if (filterStatus) filterStatus.textContent = query ? `${visible} van ${routeLinks.length} routes zichtbaar` : `${routeLinks.length} routes zichtbaar`;
    if (filterClear) filterClear.hidden = !query;
    if (noResults) noResults.hidden = visible !== 0;
  };

  const resetFilter = () => {
    if (filterInput) filterInput.value = '';
    applyFilter();
  };

  const open = () => {
    if (!panel || isOpen()) return;
    lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    previousOverflow = document.documentElement.style.overflow;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden','false');
    openers.forEach((button) => button.setAttribute('aria-expanded','true'));
    main?.setAttribute('inert','');
    header?.setAttribute('inert','');
    document.body.classList.add('dds-menu-open');
    document.documentElement.style.overflow = 'hidden';
    window.requestAnimationFrame(() => closer?.focus());
  };

  const close = () => {
    if (!panel || !isOpen()) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden','true');
    openers.forEach((button) => button.setAttribute('aria-expanded','false'));
    main?.removeAttribute('inert');
    header?.removeAttribute('inert');
    document.body.classList.remove('dds-menu-open');
    document.documentElement.style.overflow = previousOverflow;
    resetFilter();
    const returnTarget = lastFocus;
    lastFocus = null;
    window.requestAnimationFrame(() => returnTarget?.focus?.());
  };

  filterInput?.addEventListener('input', applyFilter);
  filterClear?.addEventListener('click', () => {
    resetFilter();
    filterInput?.focus();
  });
  applyFilter();

  openers.forEach((button) => button.addEventListener('click', open));
  closer?.addEventListener('click', close);
  panel?.addEventListener('click', (event) => { if (event.target === panel) close(); });

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      closer?.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || !panel.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !panel.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
